import React, {useEffect, useState} from 'react';

async function createType(authFetch, info) {
    return await authFetch(`${process.env.REACT_APP_API_URL}/type/add`, {
        method: 'POST',
        body: JSON.stringify(info),
    });
}


export default function CreateType({authFetch}) {

    // get current user info
    const [user, setUser] = useState([]);


    useEffect(() => {
        if (!authFetch) return;
        const fetchUserProfile = async () => {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/user/profile`);
            const data = await response.json();
            setUser(data);
        };

        fetchUserProfile();
    }, [authFetch]);


    const [typeName, setTypeName] = useState('');
    // const [units, setUnits] = useState([]);
    const [activeUnits, setActiveUnits] = useState('');
    const [reductionDelay, setReductionDelay] = useState('0');
    const [reductionPerHour, setReductionPerHour] = useState('0');
    const [reductionHalflife, setReductionHalflife] = useState('0');
    const [limit, setLimit] = useState('0');

    const userId = user._id;

    const handleSubmit = async e => {
        e.preventDefault();
        await createType(authFetch, {
            typeName,
            activeUnits,
            reductionDelay,
            reductionPerHour,
            reductionHalflife,
            limit,
            userId,
        });

        console.log(reductionDelay, reductionPerHour, reductionHalflife);
        //window.location.href = '/';
    };


    return (
        <>
            <h2>Create Type</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    <p>Type Name</p>
                    <input type="text" onChange={e => setTypeName(e.target.value)}/>
                </label>
                <label>
                    <p>Active Units</p>
                    <input type="text" onChange={e => setActiveUnits(e.target.value)}/>
                </label>
                <label>
                    <p>Reduction Delay (minutes)</p>
                    <input type="number" onChange={e => setReductionDelay(e.target.value)}/>
                </label>
                <label>
                    <p>Reduction Per Hour ({activeUnits})</p>
                    <input type="number" onChange={e => setReductionPerHour(e.target.value)}/>
                </label>
                <label>
                    <p>Reduction Halflife (minutes)</p>
                    <input type="number" onChange={e => setReductionHalflife(e.target.value)}/>
                </label>
                <label>
                    <p>Limit</p>
                    <input type="number" onChange={e => setLimit(e.target.value)}/>
                </label>
                <div>
                    <button type="submit">Create</button>
                </div>
            </form>
        </>
    );
}